export default __webpack_public_path__ + "static/media/877.12f1af07.svg";